import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const ChartLogin = ({chartData}) => {
  const [state, setState] = useState({
    series: [],
    options: {
      chart: {
        type: 'line',
        zoom: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },
      markers: {
        size: 5,
      },
      colors: ["#fc030b", "#247BA0", "#2d2e2e", "#009200", "#fbff03"],
      title: {
        align: 'left'
      },
      grid: {
        row: {
          colors: ['#fff', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5
        },
      },
      xaxis: {
        categories: []
      }
    }
  })

  useEffect(() => {
    setState({
      ...state,
      series: chartData?.seriesByCategory,
      options: {
        xaxis: {
          ...state.options.xaxis,
          categories: chartData?.timeInterval
        }
      }
    })
  },[chartData])

  return (
    <div className="chartLogin">
        <div className="row">
        <div id="chart">
            {
              state?.series &&
              <ReactApexChart options={state.options} series={state.series} type="line" height={300}/>
            }
        </div>
        </div>
      </div>
    );
}

export default ChartLogin;